import { styled } from '@mui/material/styles';
export var StyledContainer = styled('div')(function (_ref) {
  var isMobile = _ref.isMobile,
    theme = _ref.theme;
  return {
    width: '100%',
    paddingTop: isMobile ? 12 : 0,
    '& .MuiStepper-root': {
      paddingLeft: isMobile ? 0 : null,
      paddingRight: isMobile ? 0 : null
    },
    '& .MuiStepConnector-alternativeLabel': {
      top: 'auto',
      bottom: isMobile ? 15 : 25,
      zIndex: 0
    },
    '& .MuiStepConnector-lineHorizontal': {
      borderWidth: '2px'
    },
    '& .MuiStepConnector-completed .MuiStepConnector-lineHorizontal': {
      borderColor: theme.palette.primary.main
    },
    '& .MuiStepper-alternativeLabel': {
      alignItems: 'flex-end'
    },
    '& .MuiStepButton-root': {
      paddingTop: isMobile ? 0 : null
    },
    '& .MuiStepLabel-alternativeLabel': {
      flexDirection: 'column-reverse',
      marginTop: theme.spacing(2),
      fontWeight: theme.typography.fontWeightMedium
    },
    '& .MuiStepLabel-alternativeLabel .Mui-error': {
      color: theme.palette.secondary.main
    },
    '& .MuiStepConnector-horizontal': {
      left: isMobile ? '-50%' : null,
      right: isMobile ? '50%' : null
    },
    '& .MuiStepButton-touchRipple': {
      display: 'none'
    },
    // disabled state
    '& .MuiStepLabel-alternativeLabel:not(.Mui-error), & .MuiStep-alternativeLabel:not(.MuiStep-completed)': {
      '& .Mui-disabled .MuiStepLabel-iconContainer > div': {
        border: '1px solid rgba(236, 0, 140, 0.5)'
      },
      '& .Mui-disabled .MuiStepLabel-iconContainer > div > p': {
        color: 'rgba(236, 0, 140, 0.5)'
      }
    },
    '& .MuiStepLabel-alternativeLabel.Mui-error, & .MuiStepLabel-alternativeLabel.Mui-error.Mui-disabled': {
      '& .MuiStepLabel-iconContainer > div > p': {
        color: '#fff !important'
      }
    }
  };
});